import { Box, Button } from "@chakra-ui/react";
import { SmallArrowDownIcon } from "shared/icons/SmallArrowDownIcon";

export const ROW_EXPANDER_ICON_SIZE = 16;
export const ROW_EXPANDER_ICON_TEXT_SPACING = 3;

export interface TableRowExpandButtonProps {
  marginLeft?: string;
  isExpanded: boolean;
  onClick: () => void;
}

export const TableRowExpandButton: React.FC<
  React.PropsWithChildren<TableRowExpandButtonProps>
> = ({ marginLeft, isExpanded, onClick, children }) => (
  <Button
    variant="unstyled"
    display="flex"
    overflow="visible"
    paddingRight={0}
    paddingInlineStart={0}
    borderRadius={0}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
  >
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={`${ROW_EXPANDER_ICON_SIZE}px`}
      height={`${ROW_EXPANDER_ICON_SIZE}px`}
      marginLeft={marginLeft}
      marginRight={`${ROW_EXPANDER_ICON_TEXT_SPACING}px`}
      borderRadius="2px"
      color="gray.500"
      sx={{
        "button:hover &": {
          bg: "gray.100",
          color: "primary.600",
        },
        "button:active &": {
          bg: "gray.200",
        },
      }}
    >
      <SmallArrowDownIcon
        rotate={isExpanded ? 0 : -90}
        transform="auto"
        transitionProperty="common"
        transitionDuration="normal"
      />
    </Box>
    {children}
  </Button>
);
